export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
    textAlign: 'center',
    gap: '24px',
  },
  heading: {
    fontSize: '24px',
    fontWeight: 600,
    marginBottom: '0',
    color: '#1D2943',
    fontFamily: "'Proxima Nova', sans-serif",
  },
  description: {
    fontSize: '16px',
    color: '#707087',
    maxWidth: '800px',
    lineHeight: '24px',
    fontFamily: "'Proxima Nova', sans-serif",
  },
  button: {
    backgroundColor: '#004360',
    color: '#FFFFFF',
    borderRadius: '12px',
    padding: '8px 24px',
    fontSize: '16px',
    fontWeight: 700,
    textTransform: 'none',
    fontFamily: "'Proxima Nova', sans-serif",
    '&:hover': {
      backgroundColor: '#D63A54',
    },
  },
}
